module.exports = __webpack_public_path__ + "static/media/scrolling_marquee_100.5f04b056.ico";